<template>
	<Modal
		:value="uploadProjectVisible"
		:title="title"
		:closable="false"
		@on-ok="handleOk"
		@on-cancel="handleCancel"
	>
		<Upload
			type="drag"
			action="/api/rest_j/v1/dss/upload"
			:show-upload-list="false"
			:before-upload="beforeUpload"
			:on-success="handleSuccess"
			:on-error="handleError"
			:on-progress="handleProgress"
		>
			<div style="padding: 20px 0">
				<Icon type="ios-cloud-upload" size="52" style="color: #3399ff;" />
				<p class="el-upload__text">{{$t('message.process.resourceBar.TZDLSC')}}</p>
			</div>
		</Upload>
		<Spin
			v-if="isUploading"
			size="large"
			fix
		/>
	</Modal>
</template>

<script>
	export default {
		props: {
			uploadProjectVisible: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				title: "导入工程",
				isUploading: false
			};
		},
		methods: {
			handleOk() {
				this.$emit("upload-project");
			},
			handleCancel() {
				this.$emit("close-upload-project");
			},
			
			// 发生改变时的回调
			beforeUpload(file) {
				if (!(/\.zip$/i.test(file.name))) {
				  this.$Message.warning("导入工程只支持ZIP文件");
				  
				  return false;
				}
			},
			
			// 成功时的回调
			handleSuccess(response, file, fileList) {
				this.isUploading = false;
				
				if (response.status == 0) {
					this.$Message.success(this.$t('message.process.resourceBar.SCCG', {
						name: file.name,
					}));
				} else {
					this.$Message.warning({duration:0,closable: true,content:response.message});
				}
			},
			
			// 错误时的回调
			handleError(err, file, fileList) {
				this.isUploading = false;
					
				this.$Message.error("导入工程失败！");
			},
			
			// 上传文件过程中的回调
			handleProgress(event, file, fileList) {
				if (file.status === 'uploading') {
					this.isUploading = true;
				} else {
					this.isUploading = false;
				}
			}
		}
	};
</script>

<style scoped>

</style>
